// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dbc0deb4","453":"b2293826","732":"16892634","977":"c83b51b9"}[chunkId] + ".chunk.js";
};